module.exports = __webpack_public_path__ + "img/no-data.3e148716.png";